module.exports = __webpack_public_path__ + "img/sopra_le_dita_sx.f50c76bb.png";